define('modules/lp_info/views/variant_funnel_chart',['require','exports','module','base/itemview','highcharts','highcharts-theme','highcharts-module','highcharts-funnel'],function(require, exports, module) {
  'use strict';

  var ItemView = require('base/itemview');

  require('highcharts');
  require('highcharts-theme');
  require('highcharts-module');
  require('highcharts-funnel');

  module.exports = ItemView.extend({

    initialize: function() {
      this._configureChartFunnelColors();
      this._listenCollection();
      setTimeout(this._draw.bind(this), 0);
    },

    _listenCollection: function () {
      this.options.collection.on('sync', this._draw, this);
    },

    _configureChartFunnelColors: function () {
      Highcharts.getOptions().plotOptions.funnel.colors = (function () {
        var baseColor = '#7cb5ec';
        return _.map(_.range(0, 10), function (idx) {
          return Highcharts.Color(baseColor).brighten((idx - 3) / 7).get();
        });
      }());
    },

    _draw: function() {
      this.$el.highcharts(this._getChartOptions());
    },

    _getChartOptions: function() {
      return {
        chart: {
          type: 'funnel'
        },
        title: {
          text: ''
        },
        plotOptions: {
          series: {
            enableMouseTracking: false,
            dataLabels: {
              enabled: true,
              useHTML: true,
              distance:0,
              softConnector: true,
              formatter:function(){
                return '<div>' + this.key + '</div>';
              },
              style: {
                color: (Highcharts.theme && Highcharts.theme.textColor) || 'white',
                fontSize: '16px',
                fontWeight: 'normal',
                textShadow: '0 0 6px contrast, 0 0 3px contrast'
              }
            },
            neckWidth: '30%',
            neckHeight: '-20%',
            height: '80%',
            width: '80%',
            borderWidth: 2
          }
        },
        legend: {
          enabled: false
        },
        series: [{
          keys: ['name', 'y', 'visits', 'visitors', 'crt'],
          data: this._getChartData()
        }]
      };
    },

    _getChartData: function () {
      var series = this._getStepStatsFromCollection();
      if (!_.isEmpty(series)) {
        this._setCrt(series);
        this._setName(series);
        this._setSerieHeight(series);
      }
      return this._parseObjToArray(series);
    },

    _getStepStatsFromCollection: function () {
      var funnelIdx = this.options.funnelIdx || 0,
        model = this.collection.at(funnelIdx),
        stepStats = (model && model.has('step_stats')) ? model.get('step_stats') : [];
      return _.extend([], stepStats);
    },

    _setCrt: function (series) {
      var seriesLenght = _.size(series),
        i;
      series[0].crt = 0;
      for (i = 1; i < seriesLenght; i += 1) {
        // conversion rate is calculated from the previous step
        series[i].crt = series[i - 1].visits === 0 ? 0 : series[i].visits / series[i - 1].visits * 100;
      }
    },

    _setName: function (series) {
      var seriesLength = _.size(series);
      _.each(series, function (serie, stepIdx) {
        if (stepIdx === 0) {
          serie.name = $.i18n.t('landingPage.funnelChart.tooltip.content') + ': ' + this._getVisitsLabel(serie.visits);
        } else if (stepIdx === seriesLength - 1) {
          serie.name = $.i18n.t('landingPage.funnelChart.tooltip.confirm') + ': ' + this._getVisitsLabel(serie.visits) + ' (' + serie.crt.toFixed(2) + '%)';
        } else {
          serie.name = $.i18n.t('landingPage.funnelChart.tooltip.step') + ' ' + stepIdx + ': ' + this._getVisitsLabel(serie.visits) + ' (' + serie.crt.toFixed(2) + '%)';
        }
      }, this);
    },

    _getVisitsLabel: function (visits) {
      return visits === 1 ?
        visits + ' ' + $.i18n.t('landingPage.funnelChart.tooltip.visit') :
        visits + ' ' + $.i18n.t('landingPage.funnelChart.tooltip.visits');
    },

    _setSerieHeight: function (series) {
      var MIN_PERCENTAGE_Y = 0.02, // 2%
        STEP0_HEIGHT_WITH_DATA = 100,
        totalHeight;
      // height is the same as the conversion rate
      _.each(series, function (step) {
        step.serieHeight = step.crt;
      });
      // get total height
      totalHeight = _.reduce(series, function (total, serie) {
        return total + serie.serieHeight;
      }, 0);
      // series[0].crt is 0 by default, we set it if there is data
      if (totalHeight > 0) {
        series[0].serieHeight = STEP0_HEIGHT_WITH_DATA;
      }
      // get height percentage
      _.each(series, function (serie) {
        if (totalHeight === 0) {
          // if totalHeight is 0, all series have the same height
          serie.serieHeight = 1;
        } else {
          serie.serieHeight = serie.serieHeight / totalHeight;
          // if a height is too small, you can't see it, minimun height is 2%
          serie.serieHeight = Math.max(serie.serieHeight, MIN_PERCENTAGE_Y);
        }
      });
    },

    _parseObjToArray: function (series) {
      return _.map(series, function (serie) {
        return [serie.name, serie.serieHeight, serie.visits, serie.visitors, serie.crt.toFixed(2)];
      });
    },

    noTemplate: true

  });
});

